import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "downloadThick",
  "use": "downloadThick-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"downloadThick\"><path fill=\"none\" d=\"M19 13v4a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-4m4-5l5 5 5-5m-5 5V1\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol